import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-callback',
  template: ``
})
export class AuthCallbackComponent {
  // This component is created empty on purpose.
  // Since having componentless routes with just CanActivate, this component is used as auth/callback route component.
}
